import { Images } from "constants";
import React from "react";

const Loading = () => {
    return <>
    <div className="loaderBg">
            <img className="_loadWidth" src={Images.LOADER} alt="" />
        </div>
    </>
};

export default Loading;
